"use client";

import { watchForCookies } from "@/lib/cookies";
import fireCookieIdentified from "@/lib/tagular/fire-cookie-identified";
import { trackCustomEvent, setCustomAttributes } from "@/lib/newrelic";
import { useEffect } from "react";

let lastOptanonValue: string | null = null;

export const useCookies = () => {
  useEffect(() => {
    const cleanup = watchForCookies(
      [
        "SC",
        "PSC",
        "appFlag_exp1974",
        "appFlag_exp1989",
        "appFlag_socialOffers",
        "appFlag_socialMobile",
        "OptanonConsent",
      ],
      (cookieName, cookieValue) => {
        if (cookieName === "OptanonConsent") {
          if (lastOptanonValue === cookieValue) return;
          lastOptanonValue = cookieValue;

          fireCookieIdentified({
            key: "OptanonConsent",
            value: cookieValue,
          });

          trackCustomEvent("OptanonConsentDetected", {
            cookieValue: cookieValue,
          });

          setCustomAttributes({
            OptanonConsent: cookieValue,
          });
        } else {
          fireCookieIdentified({
            key: cookieName,
            value: cookieValue,
          });
        }
      },
      {
        interval: 500,
        timeout: 30000,
      }
    );

    return cleanup;
  }, []);
};
